<template lang="html">
  <div id="about-us-page-v2">

    <section class="main-section">
      <div class="img-bg" v-bind:style="{ backgroundImage: 'url(public/images/pages/about-us/image.jpg)' }"></div>

      <div class="container oversized-container">
        <div class="row">
          <!-- <div class="col-lg-6 col-image">
            <img src="public/images/pages/about-us/image.jpg">
          </div> -->

          <div class="col-lg-6 text-justify col-info">
            <div class="mb-2 col-s-title">
              <h2 class="text-center title-s2">Bazaar Flex</h2>
              <!-- <h3>Donde lo local se vuelve esencial.</h3> -->
            </div>

            <div class="text-justify">
              <p>
                En Bazaar Flex creemos en el poder del comercio justo y accesible. Somos un marketplace digital mexicano, especializado en equipo de telefonía, accesorios y tecnología, que conecta a vendedores de todo el país con compradores que buscan productos confiables, modernos y a buen precio.
              </p>


              <h5 class="mt-3 f-w-600">
                Nuestro objetivo es simple:
              </h5>
              <ul>
                <li>Dar a los vendedores un escaparate moderno para mostrar sus productos sin complicaciones.</li>
                <li>Brindar a los compradores una experiencia confiable y práctica, con métodos de pago seguros y envíos directos hasta la puerta de su casa.</li>
              </ul>

              <h5 class="mt-3 f-w-600">
                ¿Qué nos hace diferentes?
              </h5>
              <ul>
                <li>Marketplace 100% en línea, abierto a todos, con registro gratuito.</li>
                <li>Especialistas en telefonía, accesorios y tecnología, con las mejores opciones del mercado.</li>
                <li>Diversidad de productos, desde lo más básico hasta lo más especializado.</li>
                <li>Confianza y seguridad, con un sistema de pagos protegido y vendedores calificados.</li>
                <li>Soporte cercano, porque sabemos que detrás de cada compra hay personas que confían en nosotros.</li>
              </ul>

              <h5 class="mt-3 f-w-600">
                Nuestro compromiso
              </h5>
              <p>
                En Bazaar Flex trabajamos cada día para crear una comunidad digital justa, donde vendedores y compradores disfruten de una experiencia clara, sencilla y segura.
              </p>

              <!-- <h5 class="mt-4 welcome">¡Bienvenido a Bazaar Flex!</h5> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="vision-section">
      <div class="container oversized-container">
        <div class="box-plans">
          <!-- <h2 class="text-center title-2">Nosotros</h2> -->

          <!-- <p class="p-md text-center">
            xx
          </p> -->

          <div class="row row-plans">
            <div class="col-lg-6 col-plan">
              <h6 class="title">Misión</h6>
              <p>
                Impulsar el crecimiento de miles de emprendedores, negocios locales y marcas, ofreciendo un espacio digital donde puedan expandir su mercado y llegar a más clientes, especialmente en el mundo de la tecnología y la conectividad.
              </p>
            </div>

            <div class="col-lg-6 col-plan">
              <h6 class="title">Visión</h6>
              <p>
                Convertirnos en uno de los marketplaces más confiables y accesibles de México y Latinoamérica, siendo reconocidos por nuestra transparencia, seguridad y liderazgo en el comercio digital de telefonía y accesorios tecnológicos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- MARK: About info -->
    <ExtraAboutComponent />
    <!--  -->

  </div>
</template>

<script>
import ExtraAboutComponent from './extra-info-component.vue';
export default {
  components: {
    ExtraAboutComponent
  },

  data(){
    return{
      content: '',
      image: ''
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/nosotros')).then((response)=>{
        this.content = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
